import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const Newsletter: React.FC = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    return (
        <section className="py-24 relative overflow-hidden">
            {/* Background Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary-dark to-primary"></div>

            {/* Decorative Patterns */}
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>

            <motion.div
                className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"
                animate={{ x: [0, 30, 0], y: [0, 30, 0] }}
                transition={{ duration: 10, repeat: Infinity }}
            ></motion.div>
            <motion.div
                className="absolute bottom-0 right-0 w-80 h-80 bg-accent/20 rounded-full blur-3xl"
                animate={{ x: [0, -40, 0], y: [0, -40, 0] }}
                transition={{ duration: 12, repeat: Infinity }}
            ></motion.div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-lg rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
                            {t('newsletter.title', 'Join Our Community')}
                        </h2>
                        <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto">
                            {t('newsletter.subtitle', 'Subscribe to our newsletter to receive exclusive offers, health tips, and updates on our latest products.')}
                        </p>
                    </motion.div>

                    <motion.form
                        className="flex flex-col md:flex-row gap-4 max-w-xl mx-auto"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <input
                            type="email"
                            placeholder={t('newsletter.placeholder', 'Enter your email address')}
                            className="flex-grow px-6 py-4 rounded-full bg-white/90 border-0 focus:ring-2 focus:ring-accent focus:outline-none text-dark placeholder-gray-500 shadow-inner"
                        />
                        <button
                            type="submit"
                            className="px-8 py-4 bg-accent text-white font-bold rounded-full hover:bg-accent-dark transition-all duration-300 shadow-lg hover:shadow-glow hover:scale-105"
                        >
                            {t('newsletter.button', 'Subscribe')}
                        </button>
                    </motion.form>

                    <motion.p
                        className="mt-6 text-sm text-white/60"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                    >
                        {t('newsletter.disclaimer', 'We respect your privacy. Unsubscribe at any time.')}
                    </motion.p>
                </div>
            </div>
        </section>
    );
};

export default Newsletter;
